import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Options } from '../models/options.model';
import { combineLatest, Observable, Subject } from 'rxjs';
import { ChatContext, SkillService } from '.';
import { map } from 'rxjs/operators';

@Injectable()
export class OptionsService {
    private _chatContext$: Subject<ChatContext>;

    options$: Subject<Options>;

    constructor(
        private http: HttpClient,
        private skillService: SkillService,
    ) {
        this._chatContext$ = new Subject<ChatContext>();
        this.options$ = new Subject<Options>();
        this._chatContext$.subscribe(chatContext=>{
            let defaultSkillAddress = this.skillService.getDefaultSkillAddress(chatContext.chatRuleData.ChannelSubType);
            defaultSkillAddress.subscribe(skillAddress=>{
                const options: Options = {
                    SessionId: chatContext.sessionId,
                    Location: chatContext.location.href,
                    DefaultSkillId: '',
                    DefaultSkillAddressName: chatContext.chatRuleData.TargetSkill || skillAddress,
                    ...chatContext.chatRuleData.Proactive
                };
                this.options$.next(options);
            });
        });
    }

    getProactiveFormDetails(lang: string, formTag: string): Observable<any> {
        return this.http.get<any>(`/api/ChatAdminSettings/GetPrechatForm/${lang}/${formTag}`);
    }

    updateChatContext(context: ChatContext): void {
        this._chatContext$.next(context);
    }
}
